const addToCartButton = document.getElementById("product-add-to-cart");
const is_gift_card = document.getElementById("isGiftCard").value;
const is_subscription = Boolean(
  document.getElementById("is_subscription").value
);
is_gift_card === "true" || is_subscription === true
  ? (addToCartButton.disabled = false)
  : (addToCartButton.disabled = true);

function checkDeliveryDate(input) {
  addToCartButton.disabled = input.value.trim() === "";
}

function initializeObserver(input) {
  const observer = new MutationObserver(() => {
    checkDeliveryDate(input);
  });

  observer.observe(input, {
    attributes: true,
    attributeFilter: ["value"],
  });
  checkDeliveryDate(input);
}

function detectElementAdded(selector, callback) {
  const observer = new MutationObserver(() => {
    const element = document.querySelector(selector);
    if (element) {
      observer.disconnect();
      callback(element);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

detectElementAdded('[data-ff-product-calendar][calendar-location="product-template"] input[name="delivery_date_input"]', initializeObserver);
